// undefined input -> not dirty, don't send.
// null / "" input, or an unparseable value -> dirty clear, send null.
export const getNumberFieldValue = (
	value: unknown
): number | null | undefined => {
	if (value === undefined) return undefined;
	if (value === null || value === '') return null;
	if (typeof value === 'number') return isNaN(value) ? null : value;
	if (typeof value === 'string') {
		const parsed = parseInt(value, 10);
		return isNaN(parsed) ? null : parsed;
	}
	return null;
};
